import React, { Fragment, useState, useEffect } from 'react';
import { Button, Modal, Card, Form } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { LoadingComponent } from 'recupero-comunes'
import { desistirAsiganacion } from '../../../../api/api-recepciona-caso';
import { useFormik } from 'formik';
import { useNavigate } from 'react-router-dom'
import * as Yup from 'yup';

const Desistir = ({ showDesistir, setShowDesistir }) => {

    const history =useNavigate()

    const data_recepciona = useSelector((state) => state.recepcionaCasoReducer)
    const { cfg_form41, llaves, datosGestion } = data_recepciona;

    const [loading, setLoading] = useState(false)
    const [comentario, setComentario] = useState("");
    const [showConfirm, setShowConfirm] = useState(false);
    const [showAction, setShowAction] = useState(false);
    const [responseData, setResponseData] = useState(false);

    const formik = useFormik({
        initialValues: {
            comentario: "",
        },
        validationSchema: Yup.object().shape({
            comentario: Yup.string().required("El campo es requerido.")
        }),
        onSubmit: async (data) => {
            setComentario(data.comentario);
            setShowDesistir(false);
            setShowConfirm(true);
        }
    })

    const handleDesistir = async () => {
        setLoading(true);
        setShowConfirm(false);
        const query = {
            idCaso: llaves.idCaso,
            idImplicadoCaso: llaves.idImplicado,
            idOrganizacion: llaves.idOrgCaso,
            tipoGestion: datosGestion.datosGestion[0].codTipoGestion,
            comentario: comentario,
            idUsuario: llaves.idUsuario,
        }

        const response = await desistirAsiganacion(query);
        setResponseData(response);
        setShowAction(true);
        setLoading(false);
        setComentario("");
        formik.resetForm();
    }
    
    const queryState=JSON.parse(localStorage.getItem('filtrosRecuperoDirecto'))

    useEffect(()=>{
        if(responseData && responseData.code === 1){
            setTimeout(()=> history('/area-trabajo-recupero-directo',{state:{queryState}}),2000)      
        }
    },[responseData])

    return (
        <Fragment>
            <LoadingComponent show={loading} />
            <Modal show={showDesistir} onHide={() => setShowDesistir(false)} size='lg'>
                <Card>
                    <Form onSubmit={formik.handleSubmit}>
                        <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#4F517A', color: 'white' }}>
                            {cfg_form41 && cfg_form41.cfg_form41["recepcasoasignadodef-modaldesitir-title"]}
                        </Card.Header>
                        <Card.Body>
                            <Form.Label className="is_required">
                                {cfg_form41 && cfg_form41.cfg_form41["recepcasoasignadodef-modaldesitir-input-comentario"]}
                            </Form.Label>
                            <br />
                            <Form.Control
                                as="textarea"
                                rows={3}
                                name='comentario'
                                isInvalid={!!formik.errors.comentario}
                                value={formik.values.comentario}
                                onChange={e => formik.handleChange(e)}>
                            </Form.Control>
                            {formik.errors.comentario &&
                                <Form.Text variant='danger' style={{ color: 'red' }}>
                                    {formik.errors.comentario}
                                </Form.Text>
                            }
                        </Card.Body>
                        <Card.Footer style={{ display: 'flex', justifyContent: 'end' }}>
                            <Button className='m-2 w-auto' variant='outline-info' onClick={() => { setShowDesistir(false); setComentario(""); formik.resetForm() }}>
                                {cfg_form41 && cfg_form41.cfg_form41["recepcasoasignadodef-modaldesitir-btn-cerrar"]}
                            </Button>
                            <Button type="submit" className='m-2' variant='danger'>
                                {cfg_form41 && cfg_form41.cfg_form41["recepcasoasignadodef-modaldesitir-btn-desistir"]}
                            </Button>
                        </Card.Footer>
                    </Form>
                </Card>
            </Modal>

            <Modal show={showConfirm} onHide={() => setShowConfirm(false)} size='md'>
                <Card>
                    <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#4F517A', color: 'white' }}>
                        Confirmar
                    </Card.Header>

                    <Card.Body> ¿Confirma desistir asignación del Caso?</Card.Body>

                    <Card.Footer style={{ display: 'flex', justifyContent: 'center' }}>
                        <Button className='m-2 w-auto' variant='outline-info' onClick={() => { setShowConfirm(false); setComentario(""); formik.resetForm() }}>No</Button>
                        <Button className='m-2 ' variant='danger' onClick={handleDesistir}>Si</Button>
                    </Card.Footer>
                </Card>
            </Modal>

            <Modal show={showAction} onHide={() => setShowAction(false)} size='md'>
                <Card>
                    <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#4F517A', color: 'white' }}>
                        {responseData.code === 1 ? "Respuesta Satisfactoria" : "Error"}
                    </Card.Header>

                    <Card.Body>{responseData.message}</Card.Body>

                    <Card.Footer style={{ display: 'flex', justifyContent: 'center' }}>
                        <Button className='m-2 w-auto' variant='outline-info' onClick={() => setShowAction(false)}>Cerrar</Button>
                    </Card.Footer>
                </Card>
            </Modal>
            <style type='text/css'>
                {`
                    .is_required:after {
                        content: "(*)";
                        margin-left: 2px;
                        color: #000;
                        font-weight: 500;
                        font-size: 12pt;
                    }
                `}
            </style>
        </Fragment>
    )
}

export default Desistir;